import { Call } from '@gem/call/CallStore/Call';
import { IDeviceInfo } from '@gem/call/CallStore/Call.types';

type TCurrentDeviceChangedHandler = (deviceId: string, needToPublish?: boolean) => void;

interface IMediaDeviceServiceHandles {
  currentDeviceChangedHandler: TCurrentDeviceChangedHandler;
}

interface MediaDeviceServiceConstructorProps {
  deviceKind: MediaDeviceKind;
  handlers: Partial<IMediaDeviceServiceHandles>;
  call: Call;
}

export class MediaDeviceService {
  handlers: Partial<IMediaDeviceServiceHandles>;
  kind: MediaDeviceKind;
  call: Call;

  constructor(props: MediaDeviceServiceConstructorProps) {
    this.kind = props.deviceKind;
    this.handlers = props.handlers;
    this.call = props.call;
  }

  getDevices(devices: MediaDeviceInfo[]): void {
    const mediaDevices: IDeviceInfo[] = [];

    devices.forEach((device) => {
      const mappedDevice: IDeviceInfo = {
        deviceId: device.deviceId,
        kind: device.kind,
        label: device.label,
      };

      if (mappedDevice.kind === this.kind && device.deviceId !== 'default') {
        mediaDevices.push(mappedDevice);
      }
    });

    this.call.mediaDevices.setDevices(this.kind, mediaDevices);
  }
}
